module.exports = __webpack_public_path__ + "static/media/IMG_5703-min.993c6e47.jpg";